<template>
  <footer class="main-footer">
    <div class="container">
      <div class="row row-col-gap" data-gutter="60">
        <div class="col-md-3">
          <h4 class="widget-title-sm">Toolaku.com</h4>
          <p>The ultimate Electronic Enabler for your business</p>
          <ul class="main-footer-social-list">
            <li>
              <a class="fa fa-facebook" href="https://www.facebook.com/toolaku.toolaku.56"></a>
            </li>
            <!-- <li>
              <a class="fa fa-twitter" href="#"></a>
            </li>
            <li>
              <a class="fa fa-pinterest" href="#"></a>
            </li>
            <li>
              <a class="fa fa-instagram" href="#"></a>
            </li>
            <li>
              <a class="fa fa-google-plus" href="#"></a>
            </li> -->
          </ul>
        </div>
        <div class="col-md-3">
          <h4 class="widget-title-sm">Toolaku Component</h4>
          <ul class>
            <li>
              <router-link to="/aboutUs">
                <a href="#" style="font-size: 14px;color: #ffff;">About Us</a>
              </router-link>
            </li>
            <li>
              <router-link to="/contactUs">
                <a href="#" style="font-size: 14px;color: #ffff;">Contact Us</a>
              </router-link>
            </li>
            <li>
              <router-link to="/FAQ">
                <a href="#" style="font-size: 14px;color: #ffff;">Help/FAQ</a>
              </router-link>
            </li>
            <li>
              <router-link to="/LearningCentre">
                <a href="#" style="font-size: 14px;color: #ffff;">Learning Centre</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <h4 class="widget-title-sm">Newsletter</h4>
          <form>
            <div class="form-group">
              <label>Sign up to the newsletter</label>
              <input
                class="newsletter-input form-control"
                v-model="emailNewsletter"
                placeholder="Your e-mail address"
                maxlength="150"
                type="text"
              />
            </div>
            <div v-if="error != ''" class="alert alert-danger">
              <label>{{error}}</label>
            </div>
            <div v-if="success != ''" class="alert alert-success">
              <label>{{success}}</label>
            </div>
            <!-- <input class="btn btn-primary" type="submit" value="Sign up" /> -->
            <button
              class="btn btn-primary"
              type="button"
              @click.stop="onSubmit"
              readonly
            >{{btnName}}</button>
          </form>
        </div>
      </div>
      <ul class="main-footer-links-list">
        <li>
          <router-link to="/aboutUs">
            <a href="#" style="color: #ffff;">About Us</a>
          </router-link>
        </li>
        <li>
          <router-link to="/legal">
            <a href="#" style="color: #ffff;">Legal</a>
          </router-link>
        </li>
        <li>
          <router-link to="/customerService">
            <a href="#" style="color: #ffff;">Customer Service</a>
          </router-link>
        </li>
        <li>
          <router-link to="/privacy">
            <a href="#" style="color: #ffff;">Privacy</a>
          </router-link>
        </li>
        <li>
          <router-link to="/terms">
            <a href="#" style="color: #ffff;">Terms</a>
          </router-link>
        </li>
        <li>
          <router-link to="/press">
            <a href="#" style="color: #ffff;">Press</a>
          </router-link>
        </li>
      </ul>
      <img
        class="main-footer-img"
        src=""
        alt=""
        title="Image Title"
      />
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      emailNewsletter: "",
      error: "",
      success: "",
      btnName: "Subscribe"
    };
  },
  computed: {
    ...mapState("user", ["newsletterDetails"])
  },
  methods: {
    validateEmail(email) {
    //console.log('validateEmail ::::::::::::::: ', email);
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //console.log('validateEmail return ::::::::::::::: ', re.test(email));
    return re.test(email);
    },
    async onSubmit() {
      this.success = "";
      this.error = "";

      if (this.emailNewsletter == "" || this.emailNewsletter == null) {
        this.error = "Email is empty";
        return;
      }
      else if (this.validateEmail(this.emailNewsletter) == false) {
        //console.log('validateEmail not valid ::::::::::::::: ', this.validateEmail(this.emailNewsletter));
        this.error = "Email is not valid";
        return;
      }
      
      this.error = "";
      this.btnName = "Please Wait...";

      await this.$store.dispatch("user/addEmailNewsletter", {
        email: this.emailNewsletter
      });

      if (this.newsletterDetails.ReturnCode != 401) {
        this.btnName = "Subscribe";
        this.emailNewsletter = "";
        // setTimeout(function() {
        this.success = "Successfully Subscribed";
        //}, 5000);
        var v = this;
        setTimeout(function() {
          v.success = "";
        }, 3000);

        // this.$alert(this.newsletterDetails.ResponseMessage, "success").then(
        //   () => {
        //     this.btnName = "Subscribe";
        //     this.emailNewsletter = "";
        //   }
        // );
      } else {
        this.btnName = "Subscribe";
        this.error = this.newsletterDetails.ResponseMessage;
      }
    }
  }
};
</script>

